import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
import PageFallback from "../components/PageFallback";
export var Endpoints;
(function (Endpoints) {
    Endpoints["CATCH_ALL"] = "*";
    Endpoints["ROOT"] = "/";
    Endpoints["MAGIC_LINK_SIGN_IN"] = "/sign-in";
    Endpoints["FILE_BROWSER"] = "/file-browser";
    Endpoints["SETUP_DELIVERY"] = "/setup/delivery";
})(Endpoints || (Endpoints = {}));
export const EndpointToTabNameMap = {
    [Endpoints.CATCH_ALL]: null,
    [Endpoints.ROOT]: null,
    [Endpoints.MAGIC_LINK_SIGN_IN]: "Sign In",
    [Endpoints.FILE_BROWSER]: "File Browser",
    [Endpoints.SETUP_DELIVERY]: "Setup Delivery"
};
export const getTabName = (endpoint) => {
    var _a;
    return (_a = EndpointToTabNameMap[endpoint]) !== null && _a !== void 0 ? _a : null;
};
const LoginPage = lazy(() => import("../features/auth/login/pages/LoginPage"));
const MagicLinkSignInPage = lazy(() => import("../features/auth/magic-link-sign-in/pages/MagicLinkSignInPage"));
const FileBrowserPage = lazy(() => import("../features/file-browser/pages/FileBrowserPage"));
const SetupDeliveryPage = lazy(() => import("../features/setup-delivery/pages/SetupDeliveryPage"));
const NotFoundPage = lazy(() => import("../features/../components/NotFoundPage"));
const LazyRoute = ({ children }) => (_jsx(Suspense, Object.assign({ fallback: _jsx(PageFallback, {}) }, { children: children })));
export const LazyLoginPage = () => (_jsx(LazyRoute, { children: _jsx(LoginPage, {}) }));
export const LazyMagicLinkSignInPage = () => (_jsx(LazyRoute, { children: _jsx(MagicLinkSignInPage, {}) }));
export const LazyFileBrowserPage = () => (_jsx(LazyRoute, { children: _jsx(FileBrowserPage, {}) }));
export const LazySetupDeliveryPage = () => (_jsx(LazyRoute, { children: _jsx(SetupDeliveryPage, {}) }));
export const LazyNotFoundPage = () => (_jsx(LazyRoute, { children: _jsx(NotFoundPage, {}) }));
